import { css } from 'styled-components';

// A song's name and then a suffix on one line, the verses chosen for it ('vv. 1–3, 6', issue #4169): in a planner song
// cell, a hymn list row on the Church tab and the verses picker's preview. The name gives way first and ellipsizes, so
// an ordinary suffix shows whole; a suffix longer than two-thirds of its room (only a paste or the MCP tools make one,
// issue #4212) ellipsizes too, and the name keeps the other third.
//
// The room is the nearest box styled with suffixRoom, so the row itself may shrink to its contents (the Church tab's
// edit button sits right after the verses). A browser without container query units (Safari before 16) drops that
// cap. The planner cell and the picker preview, whose rows fill their room, take suffixAfterNameInFillingRow, which
// falls back to two-thirds of the row; the Church tab's row shrinks to its contents, where two-thirds of the row would
// clip an ordinary suffix beside a short title, so it takes suffixAfterName and such a browser shows the suffix whole
// there, inside the row that already clips it, as before #4212.
export const nameWithSuffixRow = css`
  display: flex;
  min-width: 0;
  white-space: nowrap;
`;

// the box whose width the suffix's two-thirds is of. Inline-size containment makes its width ignore its contents, so
// that width must be set from outside (a flex item that grows, a fixed width), never by what it holds
export const suffixRoom = css`
  container-type: inline-size;
`;

export const nameBeforeSuffix = css`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// where the browser can, the suffix is clipped a little outside its box, so that the edges of its first and last
// letters show as they did before anything clipped it (hidden shaves a pixel off them); elsewhere (Safari) it is hidden
export const suffixAfterName = css`
  flex-shrink: 0;
  box-sizing: border-box;
  max-width: calc(200cqw / 3);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @supports (overflow-clip-margin: 2px) {
    overflow: clip;
    overflow-clip-margin: 2px;
  }
`;

// suffixAfterName in a row that fills its room: the percentage, of the row, comes first, so it holds only where the
// browser drops the container query units
export const suffixAfterNameInFillingRow = css`
  max-width: calc(200% / 3);
  ${suffixAfterName}
`;
